import React from 'react';
import EmptyState from '../data-display/EmptyState';

const DataListContainer = ({
  isLoading,
  data,
  skeletonComponent,
  emptyStateProps = {},
  emptyStateContainerClassName = "pt-16",
  children
}) => {

  if (isLoading) {
    return skeletonComponent;
  }

  if (!data || data.length === 0) {
    return (
      <div className={emptyStateContainerClassName}>
        <EmptyState
          title={emptyStateProps.title || "No Data Found"}
          message={emptyStateProps.message || "There's nothing to show here right now."}
          icon={emptyStateProps.icon}
        />
      </div>
    );
  }

  return <>{children}</>;
};

export default DataListContainer;